import { PageShell } from "../components/layout/PageShell";
import { motion } from "framer-motion";
import { STORY } from "../data/siteContent";

export default function GaryStory() {
  return (
    <PageShell>
      {/* Hero */}
      <section data-testid="story-hero" className="relative pt-36 md:pt-44 pb-20 overflow-hidden grain">
        <div className="aurora-weave" />
        <div className="line-weave" />
        <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-[1fr_0.85fr] gap-12 items-center">
          <div>
            <p className="text-sm tracking-[0.24em] uppercase text-[#E7CC86]/80 mb-5">{STORY.hero.eyebrow}</p>
            <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-cream mb-6">
              A Life that answers to <span className="text-gold">something higher.</span>
            </h1>
            <p className="text-lg md:text-xl text-cream/70 leading-relaxed max-w-xl">{STORY.hero.sub}</p>
          </div>
          <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9 }}
            className="relative rounded-3xl overflow-hidden ring-gold-frame aspect-[4/5]">
            <img loading="lazy" src={STORY.hero.img} alt="Gary Malkin" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#080B12] via-transparent to-transparent" />
            <img loading="lazy" src="/assets/logos/gary-signature-white.webp" alt="Gary Malkin" className="absolute bottom-6 left-6 h-12 w-auto opacity-90" onError={(e) => { e.currentTarget.style.display = "none"; }} />
          </motion.div>
        </div>
      </section>

      {/* Chapters */}
      <section className="relative py-16 md:py-24 bg-[#0B1020]">
        <div className="max-w-6xl mx-auto px-5 md:px-8 space-y-10 md:space-y-16">
          {STORY.chapters.map((c, i) => {
            const flip = i % 2 === 1;
            return (
              <motion.div key={c.n}
                initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }}
                className="grid lg:grid-cols-2 gap-8 items-center glass rounded-3xl overflow-hidden">
                <div className={`relative h-64 lg:h-[24rem] ${flip ? "lg:order-2" : ""}`}>
                  <img loading="lazy" src={c.img} alt={c.title} className="absolute inset-0 w-full h-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-r from-[#0B1020]/50 to-transparent" />
                  <span className="absolute top-5 left-5 font-display text-3xl text-[#E7CC86]/85">{c.n}</span>
                </div>
                <div className={`p-8 lg:p-12 ${flip ? "lg:order-1" : ""}`}>
                  <h2 className="font-display font-semibold text-3xl lg:text-4xl text-cream mb-4">{c.title}</h2>
                  <p className="text-lg text-cream/70 leading-relaxed">{c.body}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>

      {/* Quote */}
      <section className="relative py-24 md:py-32 bg-[#080B12] overflow-hidden">
        <div className="aurora-weave slow" />
        <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8 text-center">
          <p className="font-serif italic text-2xl md:text-4xl leading-snug text-gold">“{STORY.quote}”</p>
          <p className="mt-6 text-sm tracking-[0.24em] uppercase text-cream/45">Gary Malkin</p>
        </div>
      </section>
    </PageShell>
  );
}
